import { createContext, useContext, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/services/api";
import { BRAND } from "@/lib/format";

/** Public site settings (brand, SEO, maintenance, features, ads) managed in Admin → Sozlamalar. */
export const siteConfig = { name: BRAND, seo: {}, features: {} };

const Ctx = createContext(null);

function upsertMeta(name, content) {
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!content) return el?.remove();
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function SettingsProvider({ children }) {
  const q = useQuery({ queryKey: ["settings"], queryFn: () => api.get("/settings"), staleTime: 60 * 1000, retry: 1 });
  const s = q.data;
  if (s) {
    siteConfig.name = s.site?.name || BRAND;
    siteConfig.seo = s.seo || {};
    siteConfig.features = s.features || {};
  }
  useEffect(() => {
    if (!s) return;
    upsertMeta("google-site-verification", s.seo?.google_verification);
    upsertMeta("yandex-verification", s.seo?.yandex_verification);
    upsertMeta("keywords", s.seo?.keywords);
    upsertMeta("robots", s.seo?.robots_index === false ? "noindex, nofollow" : "index, follow");
  }, [s]);
  return <Ctx.Provider value={{ settings: s, loading: q.isLoading, refetch: q.refetch }}>{children}</Ctx.Provider>;
}

export const useSettings = () => useContext(Ctx) || {};
